import React from 'react';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { BodyLarge, BodySmall } from '@shared/ui/atoms/fonts/Body';
import { MovementImage } from '@shared/ui/atoms/MovementImage';
import { iconPackPath } from '@shared/utils/WhereaboutsHelper';
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser, selectIconPack } from "@shared/store/auth.duck";
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { useTranslation } from "react-i18next";
import { isCompanyAdminUser, isOfficeAdminUser } from '@shared/utils/AccessControl';
import { warningNotification } from "@shared/store/notification.duck";

export function OfficeContentCard(props: Props) {
  const iconPack = useSelector(selectIconPack);
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  const onOfficeClicked = () => {
    if (isCompanyAdminUser(currentUser) || isOfficeAdminUser(currentUser)) {
      window.location.href = '/manage/offices/' + props.office.id
    } else {
      dispatch(warningNotification('Only company and office admins have access'));
    }
  }

  return (
    <Container onClick={onOfficeClicked}>
      <MovementImage src={iconPackPath(iconPack, 'Office.svg', FreeBusyStatus.FREE)} alt="At the office"/>
      <Column>
        <BodyLarge weight={600}>{props.office.label}</BodyLarge>
        {!!props.office.postCode && <BodySmall weight={400}>{props.office.postCode}</BodySmall>}
        {!!props.office.capacity && <BodySmall weight={400}>{props.office.capacity} {t('general.spaces-available')}</BodySmall>}
      </Column>
    </Container>
  )
}

interface Props {
  office: OfficeEntity;
}

const Container = styled.div`
  border: 1px solid ${Colours.lightGrey};
  border-radius: 8px;
  display: flex;
  padding: 20px 32px;
  margin-bottom: 12px;
  cursor: pointer;
  &:hover {
    background-color: ${Colours.veryLightGrey};
  }
`
